import { CircleCheck } from "lucide-react";
import React, { useContext, useEffect } from "react";
import { ActionIcon } from "@mantine/core";
import { Navigate } from "react-router-dom";
import useEmployeeImportDataApiService from "../services/api/EmployeeImportDataApiService";
import { HttpClientError } from "../../../providers/HttpClient";
import { queryClient } from "../../../App";
import { AuthContext } from "../../../providers/AuthProvider";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type ImportEmployeeDataActionIconProps = {
  id: number;
};

const ImportEmployeeDataActionIcon: React.FC<
  ImportEmployeeDataActionIconProps
> = ({ id }) => {
  const auth = useContext(AuthContext);
  const { showToast } = useToasts();

  const { isLoading, isSuccess, isError, mutate, error } =
    useEmployeeImportDataApiService();

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "employee_import_data_failed",
        data: { message: HttpClientError(error) },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      showToast({ strapiId: "employee_import_data_success" });

      queryClient
        .invalidateQueries([
          "EmployeeDataImportListApiService",
          auth?.employer?.id,
        ])
        .then();
    }
  }, [isSuccess]);

  if (!auth) {
    return <Navigate replace to="/login" />;
  }

  return (
    <ActionIcon
      loading={isLoading}
      onClick={() => {
        mutate(id);
      }}
    >
      <CircleCheck size={18} />
    </ActionIcon>
  );
};

export default ImportEmployeeDataActionIcon;
